import { Component, OnInit, ViewChild, Input, Output } from '@angular/core';
import { CallAPIService } from '../../../services/call-api.service' ;
import { NgForm, NgModel } from '@angular/forms' ;
import { Street } from '../../../interfaces/street.interface'
import { Router } from '@angular/router';
import { CloseDropdownService } from '../../../services/close-dropdown.service';
import { BehaviorSubject } from 'rxjs';




@Component({
  selector: 'street-select',
  template: `
    <div class="btn-group dropdown-group" 
        dropdown #streetDrop="bs-dropdown" [autoClose]="false">

        <input #streetControl="ngModel" type="text" (focus)="onFocus()" (blur)="onBlur()" (keyup)="streetChanged(streetValue)" [(ngModel)]="streetValue" class="routeInputs inline-block inputShorted" minlength="2" id="strt" name="strt" placeholder="Введіть назву вулиці та виберіть зі списку" autocomplete="off" />

        <ul [hidden]="! ( isShowStreetsList && isCloseStreetsPresent() )"  id="dropdown-triggers-manual" *dropdownMenu class="street-dropdown-menu"
          role="menu" aria-labelledby="button-triggers-manual">
          
            <div role="menuitem" *ngFor="let street of closeStreets">
            
              <button type="button" class="dropdown-item"  id="{{ 'S'+street.STREET_ID }}"
                (click)="selectStreet( street ); isShowStreetsList = false ; streetDrop.hide();"  >
                {{ street.SHORTSTREETTYPE_UA }} {{ street.STREET_UA }} <span *ngIf="street.haveOldStreetName" >({{ street.OLDSTREET_UA }}) </span>
              </button>

            </div>
          
        </ul>

        <button type="button" [disabled]="! isCloseStreetsPresent() " 
          [ngClass]="dropdownButtonClass" 
          class="btn btn-white dropdown-toggle-split  dropButton greyDropdown " 
          (click)=" isShowStreetsList = ! isShowStreetsList ; "
          formnovalidate="formnovalidate" >
            <i class="fas fa-caret-down"></i>
        </button>

    </div>
  
  `,
  styleUrls: ['./street-select.component.sass']
})
export class StreetSelectComponent implements OnInit {
  
  closeStreets: Array< Street > = Array<Street>();
  isShowStreetsList: boolean = false;
  dropdownButtonClass: string;
  lastRequestedStreets: Array<Street> ;
  lastResponseTime: any = null;
  streetValue: string;
  lastStreetPrefix: string;
  selectedStreet: Street = null;



  @ViewChild('streetDrop',{static: true}) streetDrop;
  @Input('form') form: NgForm;
  @ViewChild('streetControl',{static: true}) streetControl : NgModel ;
  @Output('newValue') newValue: BehaviorSubject<any> = new BehaviorSubject<any>(null);


  constructor(
    private API : CallAPIService ,
    private router: Router,
    private closeDropdown: CloseDropdownService,
  ) { 
    
    API.getStreetsObservable().subscribe( newStreets => {
      if( newStreets != undefined  ){
        this.lastResponseTime = Date.now();
        this.lastRequestedStreets = newStreets ;
        this.closeStreets = newStreets ;
        
        if( this.streetDrop != undefined ){
          this.streetDrop.show();
          this.isShowStreetsList = true ;
        }
        
        this.isShowStreetsList = true ;
        this.selectedStreet = null
      }
    })


  }


  ngOnInit() {
    
    this.form.addControl( this.streetControl )

    this.streetControl.valueChanges.subscribe( streetInputValue => {
      if( streetInputValue != undefined ){
        
        this.closeStreets = this.filterStreetsContains( streetInputValue ) 
        if( this.closeStreets != undefined && this.closeStreets.length > 0 ){
          this.streetDrop.show();
          this.isShowStreetsList = true ;
        } 
        
      }
    }) 


    this.API.getClearSubject().asObservable().subscribe( clear => {
      if( clear ){
        if( clear.toCleatStreet ){
          this.closeStreets = [];
          this.lastRequestedStreets = [];
          this.streetControl.control.setValue('')
        }
      }
    }  )

    // on sturtup 
    setTimeout(function(){
      this.isShowStreetsList = false ;
      if( this.streetDrop )
        this.streetDrop.hide();
    }, 200);
    
    this.closeDropdown.addDropdown('closeStreets').subscribe( ( needToClose ) => {
      if( needToClose ){
        let currentResponseTime = Date.now() ;
        let timeInterval 
        if( this.lastResponseTime == null )
          timeInterval = 100000 ;
        else
          timeInterval = currentResponseTime - this.lastResponseTime ;
        
        if( needToClose == true && this.isShowStreetsList == true && timeInterval > 1000 ){
          this.isShowStreetsList = false ;
          if( this.streetDrop )
            this.streetDrop.hide();

        }

      }
    } )
  }


  onFocus(){
    if( this.selectedStreet )
      this.streetValue = this.selectedStreet.STREET_UA;
  }

  onBlur(){
    if( this.streetValue)
      this.selectedStreet = null 

    const street = this.selectedStreet
    if( this.selectedStreet )
      this.streetValue = street.SHORTSTREETTYPE_UA +" "+ street.STREET_UA +" "+ ( street.haveOldStreetName ? street.OLDSTREET_UA : '' )

  }

  streetChanged( streetPrefix:string ){
    if(this.lastStreetPrefix && streetPrefix && this.lastStreetPrefix.length != streetPrefix.length || ! streetPrefix )
    this.newValue.next( null )

    if( streetPrefix == null ){
      this.selectedStreet = null
    }
    this.lastStreetPrefix = streetPrefix;
  }

  
  filterStreetsContains( substring: string ){
    substring = substring.toLocaleLowerCase()

    let filteredStreets: Array<Street> = [];
    if( substring.length == 0 )
      return this.lastRequestedStreets ;

    if( substring.length > 0 ){
      for( let street of this.lastRequestedStreets ){
        if( street.STREET_UA.toLocaleLowerCase().includes( substring ) ){
          filteredStreets.push( street )
        } 
      }
      
      return filteredStreets;
    }

    return [];

  }

  selectStreet( selectedStreet: any ){
    
    this.streetDrop.hide();
    //this.currentListDisplayClass = 'hidden';
    this.API.sendRequestForHouses( selectedStreet );
    this.form.controls['strt'].setValue( selectedStreet.SHORTSTREETTYPE_UA+' '+selectedStreet.STREET_UA  );
    this.newValue.next( selectedStreet );
    this.closeStreets = this.lastRequestedStreets;
    this.isShowStreetsList = false ;
    this.selectedStreet = selectedStreet;
  }

  isCloseStreetsPresent():boolean{
    
    
    if( this.closeStreets == undefined || this.closeStreets.length == undefined )
      return false
    return  ( Boolean( this.closeStreets.length ) )
  }

}
